import { Routes } from 'react-router-dom';

import { ProtectedRoute } from '@occc-app/App/routes/ProtectedRoute';
import { Feature } from '@occc/utils-access-control';
import { SentryRoute as Route } from '@occc-app/App/sentry';

import OfferCreatePage from './OfferCreatePage';
import OfferConfigurePage from './OfferConfigurePage';
import OfferUpdatePage from './OfferUpdatePage';

const Offer = () => (
  <Routes>
    <Route
      path='create'
      element={
        <ProtectedRoute feature={Feature.CAMPAIGN_COMPONENT_CREATE}>
          <OfferCreatePage />
        </ProtectedRoute>
      }
    />
    <Route path=':offerId/configure/*' element={<OfferConfigurePage />} />
    <Route path=':offerId/update/*' element={<OfferUpdatePage />} />
  </Routes>
);

export default Offer;
